// extracted by mini-css-extract-plugin
export var searchHeader = "_redotech-redo-web-lib-arbiter-components-list-redo-list-dropdown-searchHeader";
export var searchHeaderDark = "_redotech-redo-web-lib-arbiter-components-list-redo-list-dropdown-searchHeaderDark";